import { BackgroundColor } from "@silversea-ssc/ui-components-react";
import { match, P } from "ts-pattern";
import {
  PageBuilderSectionsFragment,
  PageBuilderSharedSectionRefFragment
} from "types/graphql-types";

const backgrounds: BackgroundColor[] = ["neutral01", "white"];
const nextForColor = (color: BackgroundColor): BackgroundColor => {
  if (color == "titanium" || color == "neutral10") return "white";

  return backgrounds[(backgrounds.indexOf(color) + 1) % backgrounds.length];
};

const defaultBackgroundColor = "white";
export const backgroundColorForSection = (
  section: PageBuilderSectionsFragment,
  prevSectionName: PageBuilderSectionsFragment["__typename"],
  prevSectionBackground: BackgroundColor
): BackgroundColor => {
  const defaultSectionColor = nextForColor(prevSectionBackground);
  const colorForcedByConfiguration = colorFromConfiguration(
    section,
    prevSectionBackground
  );
  if (colorForcedByConfiguration) return colorForcedByConfiguration;

  const colorForcedByPreviousSection =
    colorFromPreviousSection(prevSectionName);

  const colorForcedByCustomRules = customColor(
    section,
    colorForcedByPreviousSection || defaultSectionColor
  );

  return colorForcedByCustomRules || defaultSectionColor;
};

const colorFromPreviousSection = (
  prevSectionName: PageBuilderSectionsFragment["__typename"]
): BackgroundColor | undefined => {
  return (
    match<
      PageBuilderSectionsFragment["__typename"],
      BackgroundColor | undefined
    >(prevSectionName)
      .with("SanityFyc", () => "white")
      .with("SanityOpeningHero", () => "white")
      .with("SanityOpeningHeroSlider", () => "white")
      //.with("SanityStickyNav", () => prevSectionBackground)
      .otherwise(() => undefined)
  );
};

export const colorFromConfiguration = (
  section: PageBuilderSectionsFragment,
  prevSectionBackground: BackgroundColor
): BackgroundColor | undefined => {
  return match(section)
    .with({ __typename: "SanitySharedSectionRef" }, (s) => {
      const refSection = (s as unknown as PageBuilderSharedSectionRefFragment)
        .section?.sections?.[0];
      if (!refSection) return undefined;
      return colorFromConfiguration(refSection, prevSectionBackground);
    })
    .with({ sectionLayoutConfig: { backgroundColor: P.string } }, (s) => {
      const backgroundColor = convertNeutral05ToNeutral01(
        s.sectionLayoutConfig.backgroundColor
      );
      return backgroundColor == "previousSection"
        ? prevSectionBackground || defaultBackgroundColor
        : backgroundColor;
    })
    .otherwise(() => undefined);
};

const convertNeutral05ToNeutral01 = (
  color: BackgroundColor | undefined | "previousSection"
) => (color == "neutral05" ? "neutral01" : color);

const customColor = (
  section: PageBuilderSectionsFragment,
  defaultSectionColor: BackgroundColor
): BackgroundColor | undefined => {
  return (
    match<PageBuilderSectionsFragment, BackgroundColor | undefined>(section)
      .with({ __typename: "SanityBrochureLeadForm" }, (s) => {
        if (s.asModal)
          return match<BackgroundColor, BackgroundColor>(defaultSectionColor)
            .with("neutral05", "white", () => "neutral01")
            .with("titanium", () => "titanium")
            .otherwise(() => "neutral10");

        return "white";
      })

      .with({ __typename: "SanityCollectionMosaic" }, (s) =>
        s.collection == "offers" ? defaultBackgroundColor : "neutral01"
      )
      // .with({ __typename: "SanityFaresMosaic" }, () =>
      //   defaultSectionColor == "neutral05" ? "neutral01" : "neutral10"
      // )
      // .with(
      //   {
      //     __typename: "SanityCruiseSlider"
      //   },

      //   () => "neutral10"
      // )

      .with(
        {
          __typename: P.union(
            "SanityTextBox",
            "SanityMilestones",
            "SanityOpeningText",
            "SanityInlineCTABox",
            "SanityLocationSpecificTextBoxes"
          )
        },
        () => "white"
      )
      .with({ __typename: "SanityVideoSection" }, () => "titanium")
      .otherwise(() => defaultSectionColor)
  );
};
